const handleIframe = (iframe) => {
	if (iframe.src.includes('youtube') || iframe.src.includes('youtu.be')) {
		let wrapper = document.createElement('div');
		wrapper.classList.add('embed-responsive', 'embed-responsive-16by9');
		iframe.parentNode.insertBefore(wrapper, iframe);
		wrapper.appendChild(iframe);
	}
}

export default handleIframe;
